import { DeviceAttributesFilter } from 'components/DeviceAttributesFilter/DeviceAttributesFilter';
import type { FacetedFilterValue } from 'components/FacetedFilter/FacetedFilter';
import { FormInputError } from 'components/FormInputError/FormInputError';
import { FormLayout } from 'components/FormLayout/FormLayout';
import { FormikTextField } from 'components/FormikTextField/FormikTextField';
import { useLocale } from 'containers/App/LocaleContext';
import type { FormikProps } from 'formik';
import type { FC } from 'react';
import type { AttributePolicyFormValues } from './useAttributePolicyFormik';

interface Props {
  formik: FormikProps<AttributePolicyFormValues>;
  disabled?: boolean;
}

export const AttributePolicyForm: FC<Props> = (props) => {
  const {
    administrationPolicies: { form: policiesFormMsg },
  } = useLocale();

  const handleAttributeChange = (value: FacetedFilterValue) => {
    props.formik.setFieldValue('attributeFilters', value);
  };

  return (
    <div className='flex flex-1 flex-col'>
      <FormLayout className='pt-5' noPadding>
        <div className='flex flex-row gap-8'>
          <div className='flex-1'>
            <FormikTextField
              name='name'
              formik={props.formik}
              type='text'
              label={policiesFormMsg.fields.name}
              disabled={props.disabled}
            />
          </div>
          <div className='flex-1'>
            <FormikTextField
              name='description'
              formik={props.formik}
              type='text'
              label={policiesFormMsg.fields.description}
              disabled={props.disabled}
            />
          </div>
        </div>
        <div className='form__label'>{policiesFormMsg.fields.filter}</div>
        <DeviceAttributesFilter
          value={props.formik.values.attributeFilters}
          onChange={handleAttributeChange}
          globalAttributes
        />
        {props.formik.touched.attributeFilters && (
          <FormInputError error={props.formik.errors.filterError} />
        )}
      </FormLayout>
    </div>
  );
};
